import { RWebShare } from "react-web-share";
import ShareIcon from "../../../assets/gi/share.svg";
import { postAnalytics } from "../../../../PatientComponents/analytics";
import styled from "styled-components";
import { usePatientFacing } from "../../../flow/patientFacing/hooks/usePatientFacing";

export default function Share() {
  const { getEventDataLocal } = usePatientFacing();
  const event = getEventDataLocal();
  const caseId = event?.Case?.id;

  // const user = useUser();
  const handleAnalytic = () => {
    postAnalytics({ userId: caseId, type: "video-share" });
  };

  return (
    <RWebShare
      onClick={handleAnalytic}
      data={{
        text: "Share-Text",
        url: `${window.location.origin}/patient/start/${event?.id}`,
        title:"Share-Title",
      }}
    >
      <Container>
        <Label>
          <>Share</>
        </Label>
        <img id="ShareButton" src={ShareIcon} alt="Share" />
      </Container>
    </RWebShare>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.4rem;
`;

const Label = styled.p`
  font-family: "Abraham", sans-serif;
  color: #f02a4c;
  font-size: 0.875rem;
  margin: 0rem;
`;
